;(function () {
  angular
    .module('contrast.applications.modals')
    .controller('ApplicationServerProtectCtrl', ApplicationServerProtectCtrl)

  function ApplicationServerProtectCtrl(
    $scope,
    $q,
    $rootScope,
    ApplicationFactory,
    ServerFactory,
    ErrorService,
    logger
  ) {
    'ngInject'

    angular.extend($scope, {
      loading: true,
      servers: []
    })

    angular.extend($scope, {
      cancel: function () {
        $scope.application.popover = false
      },
      save: function () {
        var deferred = $q.defer()
        var promises = []

        angular.forEach($scope.servers, function (server) {
          if (server.defend) {
            var request = ServerFactory.toggleDefend(server.server_id).then(
              function (response) {
                logger.logSuccess(response.data.messages[0])
              },
              function (response) {
                ErrorService.processError(response)
              }
            )
            promises.push(request)
          }
        })

        $q.all(promises).then(
          function (results) {
            deferred.resolve(JSON.stringify(results))
            $scope.application.popover = false
            $rootScope.$broadcast('application.reload', [])
          },
          function (errors) {
            deferred.reject(errors)
          }
        )
      },
      check: function () {
        return _.some($scope.servers, function (server) {
          return server.defend
        })
      }
    })

    function init() {
      getServers()
    }

    function getServers() {
      ApplicationFactory.getServers(
        $scope.application.app_id,
        '',
        false,
        true
      ).then(
        function (response) {
          $scope.servers = response.data.servers
          $scope.loading = false
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    init()
  }
})()
